
  var _styles = {
  "ticket-entrance-container": {
    "width": "100%",
    "height": "2.45333rem",
    "display": "flex",
    "flexDirection": "row",
    "justifyContent": "space-between",
    "paddingTop": 0,
    "paddingRight": "0.32rem",
    "paddingBottom": 0,
    "paddingLeft": "0.32rem"
  },
  "ticket-entrance-left-container": {
    "width": "4.6rem",
    "height": "2.45333rem",
    "borderRadius": "0.48rem",
    "overflow": "hidden"
  },
  "ticket-entrance-right-container": {
    "width": "4.6rem",
    "height": "2.45333rem",
    "borderRadius": "0.48rem",
    "overflow": "hidden"
  }
};



  module.exports = _styles;
  